import type {
  ForgotPasswordDraft,
  ForgotPasswordError,
  SubmitStatus,
} from '../domain/forgot-password.model';

/**
 * Redux state for the Forgot Password form. A single-field public form, so the
 * shape is small: the editable draft, per-field validation errors, the submit
 * lifecycle, and the last business error. No `sent` boolean; the success view
 * is `status === 'succeeded'` (the draft email survives success so the
 * confirmation copy can echo it). Every field is serialisable.
 */
export interface ForgotPasswordState {
  draft: ForgotPasswordDraft;
  validationErrors: Record<string, string>;
  status: SubmitStatus;
  error: ForgotPasswordError | null;
}

export const emptyDraft: ForgotPasswordDraft = { email: '' };

export const initialState: ForgotPasswordState = {
  draft: emptyDraft,
  validationErrors: {},
  status: 'idle',
  error: null,
};
